/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-plusplus */
/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, {
  useState, useMemo, useRef, useEffect,
} from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import DraggableContent from './DraggableContent';
import {
  setExpandedItem,
  removeExpandedItem,
  setSessionBreakCollapsed,
  clearMostRecentlyAddedCalendarItemTracker,
} from '../../ducks/calendarActions';
import { flushDebounceForTable } from './hooks/debounceHandler';
import useCalendarDnDMapping from './hooks/useCalendarDnDMapping';
import useIsMobile from '../../../../shared/hooks/useIsMobile';

const EMPTY_ARRAY = [];

const DraggableDiv = styled('div')`
  border-radius: ${(props) => (props.isDragging || props.isHovered ? '4px' : 'none')};
  border: ${(props) => (props.isDragging || (props.isHovered && !props.disableBlueBorder) ? '1px dashed #77A7FF' : 'white')};
  box-shadow: ${(props) => (props.isDragging ? `${BoxShadow}` : 'none')};
  background: ${(props) => props.customBackground || 'white'};
  transition: none;
  margin-top: ${(props) => {
    if (!props.addMarginTop) return null;
    if (props.isSessionBreak) return props.isTvMode ? '4px' : '8px';
    return props.isTvMode ? '1px' : '3px';
  }};
  margin-bottom: ${(props) => props.addMarginBottom && (props.isTvMode ? '1px' : '3px')};
`;

const DraggableDivWrapper = ({
  cache,
  isWeekView,
  isDayExpanded,
  date,
  dayNumber,
  item,
  index,
  id,
  measure,
  onDayExpand,
}) => {
  const contentRef = useRef(null);
  const isMobile = useIsMobile();
  const selectedItem = useSelector((state) => (state.calendar.data.selectedItems[item.assignedId]));
  const dispatch = useDispatch();
  const [hoveredId, setHoveredId] = useState(null);
  const [localAdditionalInfo, setLocalAdditionalInfo] = useState('');
  const [localDescription, setLocalDescription] = useState('');
  const expandedItem = useSelector((state) => state.calendar.data.expandedItems[item.assignedId]);
  const mostRecentlyAddedCalendarItem = useSelector(
    (state) => state.calendar.data.mostRecentlyAddedCalendarItem,
  );
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const effectiveSelectedProgramDayNumber = dayNumber || selectedProgramDayNumber;
  const endpointFormattedDate = useMemo(
    () => (effectiveDate ? moment(effectiveDate).format('YYYY-MM-DD') : null),
    [effectiveDate],
  );
  const programType = useSelector((state) => state.calendar.data.programType);
  /** both selectors run unconditionally to respect rules of hooks */
  const nonDateItems = useSelector(
    (state) => state.calendar.data.nonDateBasedProgramItems[
      effectiveSelectedProgramDayNumber
    ]?.exercises || EMPTY_ARRAY,
  );
  const dateItems = useSelector(
    (state) => (endpointFormattedDate
      ? state.calendar.data.calendarItems[endpointFormattedDate]?.exercises || EMPTY_ARRAY
      : EMPTY_ARRAY),
  );
  const calendarItems = programType === 'free-form-program' ? nonDateItems : dateItems;

  const {
    getItemsUnderSessionBreak,
    getSessionBreakAbove,
  } = useCalendarDnDMapping(calendarItems);

  const isCalendarOptionsDropdownMenuOpen = useSelector(
    (state) => state.calendar.data.isCalendarOptionsDropdownMenuOpen,
  );
  const isStaticAddColumnDropdownMenuopen = useSelector(
    (state) => state.calendar.data.isStaticAddColumnDropdownMenuOpen,
  );
  const draggedItem = useSelector((state) => state.calendar.data.draggedItem);
  const isTvMode = useSelector((state) => state.calendar.ui.isTvMode);

  const doesGroupingLetterAboveItemMatchContent = useMemo(
    () => !!item.groupingLetter
      && item.groupingLetter === calendarItems[index - 1]?.groupingLetter,
    [item.groupingLetter, calendarItems, index],
  );

  const doesGroupingLetterBelowItemMatchContent = useMemo(
    () => !!item.groupingLetter
      && item.groupingLetter === calendarItems[index + 1]?.groupingLetter,
    [item.groupingLetter, calendarItems, index],
  );

  /** Find which session break governs this item */
  const sessionBreakAbove = useMemo(
    () => getSessionBreakAbove(item),
    [getSessionBreakAbove, item],
  );

  /** Derived from sessionBreakAbove — true when any session break exists above */
  const isItemBelowASessionBreak = !!sessionBreakAbove;

  /** Scoped selector — only re-renders when THIS session break's expansion changes */
  const isSessionBreakAboveExpanded = useSelector(
    (state) => (sessionBreakAbove
      ? !!state.calendar.data.expandedItems[sessionBreakAbove.assignedId]
      : false),
  );

  const selectedItemIdsForDay = useSelector((state) => {
    const items = state.calendar.data.selectedItems;
    if (!items || !Object.keys(items).length) return EMPTY_ARRAY;
    let exercises;
    if (programType === 'free-form-program') {
      exercises = state.calendar.data
        .nonDateBasedProgramItems[effectiveSelectedProgramDayNumber]?.exercises;
    } else if (endpointFormattedDate) {
      exercises = state.calendar.data
        .calendarItems[endpointFormattedDate]?.exercises;
    }
    if (!exercises) return EMPTY_ARRAY;
    return exercises
      .filter((calItem) => items[calItem.assignedId])
      .map((calItem) => String(calItem.assignedId));
  }, shallowEqual);

  const itemIsInDragGroup = selectedItemIdsForDay.includes(
    String(item.assignedId),
  );

  const draggedItemIsInDragGroup = selectedItemIdsForDay.includes(
    String(draggedItem?.assignedId),
  );

  const shouldCollapseItemInMultiSelectDragGroup = Boolean(draggedItem) // a drag is happening
  && draggedItemIsInDragGroup // dragging a selected item
  && itemIsInDragGroup // this item is selected
  && item.assignedId !== draggedItem.assignedId; // not the dragged item

  /** pre-compute once — used in useEffect deps, computedStyle, and render */
  const shouldCollapseUnderSessionBreak = useMemo(() => {
    if (
      draggedItem?.type === 'session_break'
      && getItemsUnderSessionBreak(draggedItem)?.[item.assignedId]
    ) {
      return true;
    }
    if (
      sessionBreakAbove
      && !sessionBreakAbove.preSave
      && getItemsUnderSessionBreak(sessionBreakAbove)?.[item.assignedId]
      && !isSessionBreakAboveExpanded
    ) {
      return true;
    }
    return false;
  }, [
    draggedItem,
    item,
    sessionBreakAbove,
    isSessionBreakAboveExpanded,
    getItemsUnderSessionBreak,
  ]);

  useEffect(() => {
    /** Only run when there is a recently added calendar item && when calendarItems.length exists &&
     * when the item is a session break
     *  and when the most recently added item exists underneath the session break */
    if (mostRecentlyAddedCalendarItem && calendarItems?.length && item?.type === 'session_break' && getItemsUnderSessionBreak(item)?.[mostRecentlyAddedCalendarItem?.assignedId]) {
      dispatch(setExpandedItem(item));
      dispatch(clearMostRecentlyAddedCalendarItemTracker());
    }
  }, [mostRecentlyAddedCalendarItem]);

  const hasMounted = useRef(false);
  const hasMountedMeasureEffect = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      /** skip first run because cell measurer wrapper will get that
       * and we don't want to run it twice */
      hasMounted.current = true;
      return;
    }

    if (measure) {
      /** we need to clear the cache because we have to account
       * for session break items and hidden items, there are alot of
       * instances where we need the cache to clear so we can update the layout and don't
       * retain the layout from the old heights
       */
      cache.clearAll();
      measure();
    }
  }, [
    measure,
    expandedItem,
    shouldCollapseUnderSessionBreak,
    shouldCollapseItemInMultiSelectDragGroup,
  ]);

  /** we need to call measure when additional/description info gets updated because
   * that changes the heigth of the cell. However, we do not need to do
   * cache.clearAll for additional info/ description udates so we are pulling
   * this out into it's own useEffect
   */
  useEffect(() => {
    if (!hasMountedMeasureEffect.current) {
      /** skip first run because cell measurer wrapper will get that
       * and we don't want to run it twice */
      hasMountedMeasureEffect.current = true;
      return;
    }

    if (measure) {
      measure();
    }
  }, [
    measure,
    localAdditionalInfo,
    localDescription,
  ]);

  const handleClick = () => {
    if (expandedItem) {
      if (item?.type === 'session_break') {
        dispatch(setSessionBreakCollapsed(item));
      } else {
        dispatch(removeExpandedItem(item));
      }
    } else {
      dispatch(setExpandedItem(item));
    }
  };

  const typeDoesNotExpand = (typeItem) => {
    if (
      typeItem.type === 'warm_up'
      || typeItem.type === 'W'
      || typeItem.type === 'health'
      || typeItem.type === 'H'
      || typeItem.type === 'note'
      || typeItem.type === 'N'
      || typeItem.type === 'cooldown'
      || typeItem.type === 'CD'
    ) {
      return true;
    }
    return false;
  };

  const handleIsCheckBoxForTypeVisible = (checkBoxItem) => {
    /** if hovered or check box is selected the checkbox should always be visible */
    if (hoveredId === `${checkBoxItem.assignedId}-programmedCalendarItems` || selectedItem) {
      return true;
    }
    return false;
  };

  const handleMouseLeave = () => {
    setHoveredId(null);
    flushDebounceForTable(item.assignedId);
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      const isInsideContainer = contentRef.current?.contains(e.target);

      if (isCalendarOptionsDropdownMenuOpen || isStaticAddColumnDropdownMenuopen) return;

      if (!isInsideContainer) {
        flushDebounceForTable(item.assignedId);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isCalendarOptionsDropdownMenuOpen, isStaticAddColumnDropdownMenuopen]);

  const isAnySwapLoading = useSelector(
    (state) => Object.keys(state.calendar.ui.swapLoadingAssignedIds).length > 0,
  );
  const isAnyItemSaving = useSelector(
    (state) => Object.keys(state.calendar.ui.savingAssignedIds).length > 0,
  );

  return (
    <Draggable
      key={item.assignedId}
      /** if any item is being swapped or saved we disable drag across the board
       * to avoid moving stale items mid-swap and to prevent an in-flight save
       * from racing with a cross-day move (the move endpoint would receive the
       * pre-save string id and the save response would land on a stale date) */
      isDragDisabled={isAnySwapLoading || isAnyItemSaving}
      draggableId={`${item.assignedId}-programmedCalendarItems`}
      index={index}
    >
      {(draggableProvided, snapshot) => {
        const itemHoveredOverId = snapshot?.combineTargetFor?.split('-programmedCalendarItems')[0];
        const itemHoveringOver = calendarItems?.find(
          (calendarItem) => calendarItem?.assignedId?.toString() === itemHoveredOverId,
        );
        const itemIdStr = `${item.assignedId}-programmedCalendarItems`;

        const computedStyle = {
          ...(draggableProvided.draggableProps.style),
          opacity: (shouldCollapseUnderSessionBreak
            || shouldCollapseItemInMultiSelectDragGroup) ? 0 : 1,
        };

        const shouldHighlight = (
          (hoveredId === itemIdStr && !expandedItem && !item.preSave)
          || (hoveredId === itemIdStr && typeDoesNotExpand(item))
          || selectedItem
        );

        const computedBackground = shouldHighlight ? 'rgba(252, 252, 252, 1)' : (item.type === 'session_break' || isItemBelowASessionBreak) ? '#F8F8F8' : 'white';

        const setRefs = (node) => {
          contentRef.current = node;
          draggableProvided.innerRef(node);
        };

        const isCollapsed = shouldCollapseUnderSessionBreak
          || shouldCollapseItemInMultiSelectDragGroup;

        /** Phones: native scrolling and rbd's long-press touch sensor fight
         * over the same gesture when the whole item is the drag handle, so
         * dragHandleProps move onto the item's type icon (IconContainer in
         * DraggableContent, with touch-action: none) and the rest of the item
         * body scrolls the list natively. Collapsed (invisible, opacity-0)
         * items keep the root spread - they render no content to host the
         * handle. Desktop is unchanged: both prop sets stay on the root.
         * Known limitation: week-view touch drags to off-screen day columns
         * are unsupported (rbd can't autoscroll nested scroll containers);
         * far moves are covered by the copy modal. */
        const useDedicatedHandle = isMobile && !isCollapsed;

        return (
          <DraggableDiv
            onMouseEnter={() => {
              setHoveredId(itemIdStr);
            }}
            onMouseLeave={handleMouseLeave}
            ref={setRefs}
            {...draggableProvided.draggableProps}
            {...(useDedicatedHandle ? {} : draggableProvided.dragHandleProps)}
            isDragging={snapshot.isDragging}
            style={computedStyle}
            customBackground={computedBackground}
            isHovered={snapshot.combineTargetFor != null}
            disableBlueBorder={item.type === 'session_break' || itemHoveringOver?.type === 'session_break' || item?.type === 'questionnaire' || itemHoveringOver?.type === 'questionnaire'}
            addMarginTop={!doesGroupingLetterAboveItemMatchContent && index !== 0
              && !isItemBelowASessionBreak}
            isSessionBreak={item.type === 'session_break'}
            addMarginBottom={!doesGroupingLetterBelowItemMatchContent && item.type !== 'session_break' && !isItemBelowASessionBreak}
            isWeekView={isWeekView}
            isTvMode={isTvMode}
          >
            {/* we need to add a div so that react beautiful dnd -
            does not default to null
             dnd needs a div to track if all items are selected and collapsed -
            this prevents edge cases from breaking the drag
              for example if a user select all items and then tries to drag all
              having null will break the drag
            */}
            {isCollapsed ? <div /> : (
              <DraggableContent
                dragHandleProps={useDedicatedHandle
                  ? draggableProvided.dragHandleProps : null}
                localDescription={localDescription}
                setLocalDescription={setLocalDescription}
                localAdditionalInfo={localAdditionalInfo}
                setLocalAdditionalInfo={setLocalAdditionalInfo}
                measure={measure}
                isHovered={snapshot.combineTargetFor != null}
                itemHoveringOverCurrentItem={itemHoveringOver}
                itemIsHoveredByMouse={hoveredId === itemIdStr}
                isDragging={snapshot.isDragging}
                content={item}
                index={index}
                shouldShowQuickActions={shouldHighlight}
                isExpanded={!!expandedItem}
                setIsExpanded={() => handleClick(item.assignedId)}
                isDayExpanded={isDayExpanded}
                date={effectiveDate}
                dayNumber={effectiveSelectedProgramDayNumber}
                checkboxVisible={
                  typeDoesNotExpand(item)
                    ? handleIsCheckBoxForTypeVisible(item)
                    : (hoveredId === itemIdStr || selectedItem || !!expandedItem) || item.preSave
                  }
                isWeekView={isWeekView}
                onDayExpand={onDayExpand}
              />
            )}
          </DraggableDiv>
        );
      }}
    </Draggable>
  );
};

export default DraggableDivWrapper;
